import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
//import * as flightInfoTypes from './flightInfoTypes'

const useStyles = makeStyles(theme => ({

    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },

}));
const Passenger = (props) => {

    console.info("passenger header", props);
    let { selectedFlightInfo} = props
    let isTerminatorFlight = selectedFlightInfo.TerminatorFlight > 0

    console.info("passenger header selectedFlightInfo", selectedFlightInfo);
    let paxDetails = []
    let totalPax  =  0
    let totalPaxInbound = 0 
    if (selectedFlightInfo.PassengerDetails != null) {
        if(isTerminatorFlight)
        {
            paxDetails = selectedFlightInfo.PassengerDetails.filter(pax => pax.Direction == '2' && pax.Confirmed > 0)
        }else{
            paxDetails = selectedFlightInfo.PassengerDetails.filter(pax => pax.Direction == '1' && pax.Confirmed > 0)
        }
        totalPax = paxDetails.length     
      }

      //In SelectedflightInfo find out Inbound flights started      
      const hello = selectedFlightInfo.PassengerDetails.filter(dd=> {        
          return (dd.FlightNumber == parseInt(selectedFlightInfo.FltNumInbound) &&
          dd.ArrivalStation == 'YTZ')       
      });

      console.info("final list",hello);      
      // ended

    const [expanded, setExpanded] = React.useState(false);
    const classes = useStyles();
    function handleExpandClick() {
        setExpanded(!expanded);
    }
    return (
        <div className="floatRight">Total Inbound Passengers: {totalPax}             
        </div>
    )
}

export default Passenger